import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';

const SocialLinksModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);

    let initialData = {
        Sn: 0,
        Platform: '',
        Url: ''
    };

    const [linkData, setLinkData] = useState(initialData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setLinkData({ Sn: item.Sn, Platform: item.Platform, Url: item.Url });
            }
            setModalBox(true);
        }
    }));

    const handleSaveLink = () => {
        if (linkData.Url.trim().length === 0) {
            toast.error("Please Enter URL");
            return;
        }

        const endpoint = `/updateSocialLink/${linkData.Sn}`;
        axios.post(BACKEND_SERVER_URL + endpoint, linkData)
            .then((response) => {
                toast.success(response.data.message);
                props.setLinkLoading(!props.loadLinks);
                setModalBox(false);
            }).catch(error => {
                console.log(error);
                toast.error(error.response?.data?.message || "Error saving Social Link");
            });
    }

    useEffect(() => {
        if (!modalBox) {
            setLinkData(initialData);
        }
    }, [modalBox]);

    return (
        <Modal onHide={() => setModalBox(false)} show={modalBox} size="md" backdrop="static" keyboard={false}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Edit {linkData.Platform} Link</h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label text-primary">Platform</label>
                        <input className='form-control' type="text" value={linkData.Platform} disabled />
                    </div>
                    <div className="mb-3">
                        <label className="form-label text-primary">URL<span className="required">*</span></label>
                        <input autoFocus className='form-control' type="text" value={linkData.Url} 
                            onChange={(e) => setLinkData({ ...linkData, Url: e.target.value })} />
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs " onClick={handleSaveLink}>
                        Update
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default SocialLinksModal;
